import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';
import DownloadFile from './../../../commons/DownloadFile.js';

export default class GoodsStatusUpdate extends Component {
	render(){
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Goods Status Update
					</div>
					<div>
						<DownloadFile title="Goods Status Update Header" url="ingest/seller-return/goods-compensation/template"/>
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/seller-return/goods-compensation"/>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SellerReturns/Components/GoodsStatusUpdate.js